export const TEMPLATE_LIST_REQUEST="TEMPLATE_LIST_REQUEST"
export const TEMPLATE_LIST_SUCCESS="TEMPLATE_LIST_SUCCESS"
export const TEMPLATE_LIST_FAIL="TEMPLATE_LIST_FAIL"
export const TEMPLATE_GET_REQUEST="TEMPLATE_GET_REQUEST"
export const TEMPLATE_GET_SUCCESS="TEMPLATE_GET_SUCCESS"
export const TEMPLATE_GET_FAIL="TEMPLATE_GET_FAIL"
export const GET_TEMPLATE_FILTERS_SUCCESS="GET_TEMPLATE_FILTERS_SUCCESS"
export const GET_TEMPLATE_FILTERS_FAIL = "GET_TEMPLATE_FILTERS_FAIL"
export const GET_TEMPLATE_FILTERS_REQUEST= "GET_TEMPLATE_FILTERS_REQUEST"